import React from "react";
import "./support.scss";
import { Element } from "react-scroll";
import { Link } from "react-scroll";
import { NavLink } from "react-router-dom";

const Whatwedo = () => {
  return (
    <>
      <div className="maincontent">
        <div className="innercontent">
            <div>
          <Element name="whatwedo">
            <h1 className="mainhead">What we do</h1>
            <p className="mainpara">
              tomi is building a decentralized super app that combines privacy,
              security, and seamless web3 functionality in one powerful
              platform. Our ecosystem offers users a censorship-resistant
              alternative to the traditional internet, enabling secure
              communication, financial transactions, and content sharing—all
              without compromising freedom.
            </p>
            <p className="mainpara">
              The tomi super app integrates key features such as a private
              browser, encrypted messaging, decentralized identity, and web3
              payments, giving users complete control over their digital
              interactions. Whether you're browsing, transacting, or engaging
              with decentralized communities, tomi provides a frictionless
              experience designed for the next generation of the internet.
            </p>
          </Element>
          </div>
          <div className="bottom-btns">
            <NavLink exact to="/support/welcome" className="innerbtn firstbtn">
              <div className="leftbtn">
                <p className="innerbtnpara">Previous</p>
                <p className="innerbtnhead">Welcome to tomi Help Center</p>
              </div>
              <span className="arrowmain">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="15"
                  viewBox="0 0 14 15"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.06049 4.55397L9.37832 4.23613L8.74265 3.60046L8.42482 3.9183L5.05367 7.28944L4.73584 7.60728L5.05367 7.92511L5.34095 8.21239L6.34791 7.26654L9.06049 4.55397ZM6.26778 7.86788L6.02193 8.89337L8.42482 11.2963L8.74265 11.6141L9.37832 10.9784L9.06049 10.6606L6.26778 7.86788Z"
                    fill="#0E1120"
                  />
                </svg>
              </span>
            </NavLink>
            {/* <NavLink exact to="/support/ourfeatures" className="innerbtn">
              <div className="leftbtn">
                <p className="innerbtnpara">Next - Overview</p>
                <p className="innerbtnhead">Our Features</p>
              </div>
              <span className="arrowmain">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="15"
                  viewBox="0 0 14 15"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.06049 4.55397L9.37832 4.23613L8.74265 3.60046L8.42482 3.9183L5.05367 7.28944L4.73584 7.60728L5.05367 7.92511L5.34095 8.21239L6.34791 7.26654L9.06049 4.55397ZM6.26778 7.86788L6.02193 8.89337L8.42482 11.2963L8.74265 11.6141L9.37832 10.9784L9.06049 10.6606L6.26778 7.86788Z"
                    fill="#0E1120"
                  />
                </svg>
              </span>
            </NavLink> */}
          </div>
        </div>
        <div className="right-sidebar">
          <div className="main-heading">
            <span>On this page</span>
          </div>
          <div className="rightlinks">
            <Link
              to="whatwedo"
              activeClass="active-link"
              spy={true}
              smooth={true}
              duration={300}
            >
              What we do
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Whatwedo;
